<template>
    <div class="discuss">
        <div class="discuss-main-title">
            <!-- 顶部标题 -->
            <title-bar
                v-bind:className="'discuss-main-title-bar'"
                v-bind:titleData="titleData"
                v-bind:createFunc="clickCreateDiscuss">
            </title-bar>
            <!-- 主要两个大的tab -->
            <div class="discuss-main-tab dsp-flex">
                <div class="discuss-main-tab-item one" @click="clickMainTab(1)">
                    <p class="title1">已保存论盘记录</p>
                    <p class="title2">随时复盘学习</p>
                </div>
                <div class="discuss-main-tab-blank"></div>
                <div class="discuss-main-tab-item two" @click="clickMainTab(2)">
                    <p class="title1">我参与的论盘</p>
                    <p class="title2">看看自己的论断</p>
                </div>
            </div>
            <div class="layout-sub-ymd-title">
                <div class="layout-sub-ymd-title-box dsp-flex">
                    <div class="ymd-title-box-left"></div>
                    <div class="ymd-title-box">
                        <div class="ymd-title-box-box" v-bind:class="{'direct-rtl': parseInt(settingConfigData.nianyueRishi) == 1}">
                            <span class="title-span"><span v-for="string in stringArr">{{string}}</span></span>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <!-- 列表部分 -->
        <div class="discuss-main-list">
            <discuss-hot-virtual-list></discuss-hot-virtual-list>
        </div>

        <!-- 新建论盘入口 -->
        <div class="famous-add" @click="clickCreateDiscuss">
            <div class="famous-add-btn discuss-add-btn"><i class="iconfont icon-plus-2"></i></div>
        </div>

        <router-view></router-view>
    </div>
</template>

<script>
import TitleBar from '../components/TitleBar.vue'
import DiscussHotVirtualList from '../layouts/discuss/DiscussHotVirtualList.vue'
import { MIX } from '../modules/utils';
export default {
    name: 'DiscussPage',
    components: { TitleBar, DiscussHotVirtualList },
    computed: {
        gotRecordData() {
            return this.$store.state.record.gotRecordData;
        },
        settingConfigData() {
            return this.$store.state.setting.settingConfigData;
        },
    },
    data() {
        return {
            titleData: {showCancel: false, hideBack: true, titleText: '论盘精进', titleCreate: '新建'},
            stringArr: ['年', '月', '日', '时'],
        }
    },
    mounted() {
        var me = this;
        this.$store.dispatch('initBasicData');
        this.$store.dispatch('discuss/resetData');
        this.$store.dispatch('discuss/initHotLunPanList', {
            cb: function() {
                setTimeout(() => {
                    me.$bus.emit('updateDiscussHotListDom');
                }, 20);
            }
        });
        setTimeout(() => {
            MIX.trackPageViewed('WorldLunPanPage');
        }, 20);
        // 加载完成后,静默加载全部列表数据
        if(!this.gotRecordData){
            this.$store.dispatch('record/initRecordList');
        }
    },
    methods: {
        clickMainTab(tab) {
            if(tab == 1) {
                MIX.trackButtonClicked('lunpan_list_saved');
            }else if(tab == 2) {
                MIX.trackButtonClicked('lunpan_list_jioned');
            }
            this.$store.state.discuss.secondLunpanTab = tab;
            this.$router.push({
                path: '/discusssecond'
            });
        },
        clickCreateDiscuss() {
            // this.$router.push({
            //     path: '/discusscreate'
            // });
            MIX.trackButtonClicked('lunpan_list_create_lunpan');
            this.$store.dispatch('allrecord/resetRecordData');
            this.$store.state.chooserecord.chooseFromPage = 'discussmain';
            this.$store.state.chooserecord.chooseRecordType = 'single';
            this.$router.replace('/discussmain/chooserecord');
        }
    }
}
</script>